<template>
    <span @click="goBack">
        <SafeIcon type="fanhui" class="top-icon"/>
    </span>
</template>

<script setup>
    // icon-fanhui
    import {isLogin} from "../utils/llm.tools";
    const href = isLogin()? '/recent': '/mobile/home';
    const goBack = () => window.location.href = href;
</script>

